import { useEffect } from 'react';

import { lunarReviewsItem } from 'app/fuse-configs/navigation/config/sharedNavigationItems';
import {
  selectNavigation,
  selectNavigationAll,
  updateNavigationBadge,
} from 'app/store/fuse/navigationSlice';
import { useAppDispatch, useAppSelector } from 'app/store/hooks';
import FuseUtils from '@/@fuse/utils';

import useLunarRunStats from './useLunarRunStats';

/**
 * Keeps the Lunar Reviews sidebar count at the number of runs awaiting review. The stats are only
 * fetched while the sidebar shows the item, which is the UK navigation for support users. The
 * count is put back whenever the item lacks it, because picking a pharmacy resets the navigation.
 */
export default function useLunarReviewsNavBadge(): void {
  const dispatch = useAppDispatch();
  const isShown = useAppSelector((state) =>
    Boolean(FuseUtils.findNavItem(selectNavigation(state), lunarReviewsItem.id))
  );
  const shownCount = useAppSelector((state) => {
    const title = FuseUtils.findNavItem(selectNavigationAll(state), lunarReviewsItem.id)?.badge
      ?.title;
    return typeof title === 'number' ? title : 0;
  });
  const pendingCount = useLunarRunStats({ enabled: isShown }).data?.pendingCount;

  useEffect(() => {
    if (pendingCount === undefined || pendingCount === shownCount) return;
    dispatch(updateNavigationBadge(lunarReviewsItem.id, pendingCount));
  }, [dispatch, pendingCount, shownCount]);
}
